import type { Asset, Stored, User } from "@overmap-ai/common"
import { UNLABELLED_ASSET_LABEL } from "@overmap-ai/common"

export const assetSortFn = (a: Stored<Asset>, b: Stored<Asset>) => {
	return (a.label || UNLABELLED_ASSET_LABEL).localeCompare(b.label || UNLABELLED_ASSET_LABEL)
}

export const userSortFn = (a: User, b: User) => {
	return a.email.localeCompare(b.email)
}

export const assigneeSortFn = (a: User | null, b: User | null) => {
	if (a === null) return b === null ? 0 : -1
	if (b === null) return 1
	return userSortFn(a, b)
}
